import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Chip,
  TextField,
  Grid,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { createInspectionJob } from "../../assets/images";
import moment from "moment";
import { OAuth as OAuthActions } from "../../js/actions";
import { useDispatch } from "react-redux";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import HourglassEmptyOutlinedIcon from "@material-ui/icons/HourglassEmptyOutlined";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import GroupAddOutlinedIcon from "@material-ui/icons/GroupAddOutlined";
import { setSnackbar } from "../../js/reducers/snackbar";
import { useHistory } from "react-router-dom";
import { Context } from "../../js/utils/Context";
import MenuBookIcon from "@material-ui/icons/MenuBook";

const COLORS = {
  blue100: "#dbeafe",
  blue700: "#1d4ed8",
};

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    padding: "24px",
    margin: "0 auto",
    backgroundColor: "#f0f2f7",
    "& .MuiButton-root": {
      lineHeight: 1.2,
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
    gap: 16,
    flexWrap: "wrap",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  headerIcon: {
    width: 40,
    height: 40,
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: "24px !important",
    fontWeight: 700,
    color: "#0f172a",
    letterSpacing: -0.4,
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },
  cardFlexContainer: {
    display: "flex !important",
    marginBottom: 20,
  },
  gridImageContainer: {
    height: "100% !important",
    width: "100% !important",
    objectFit: "cover !important",
  },
  cardContentContainer: {
    flex: "1 !important",
    display: "flex !important",
    flexDirection: "column !important",
    gap: "14px !important",
  },
  pageIconBox: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: COLORS.blue100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  pageTitleIcon: {
    fontSize: "22px !important",
    color: COLORS.blue700,
  },
  infoTitle: {
    fontSize: "13px !important",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#1a56db",
    marginBottom: 4,
  },
  fieldRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
  },
  fieldLabel: {
    fontSize: "13px !important",
    fontWeight: 600,
    color: "#64748b",
    minWidth: 110,
    paddingTop: 1,
  },
  fieldValue: {
    fontSize: "13px !important",
    fontWeight: 500,
    color: "#0f172a",
    background: "#f8fafc",
    padding: "3px 10px",
    borderRadius: 6,
    border: "1px solid #e2e8f0",
    wordBreak: "break-all",
  },
  fieldValue1: {
    fontSize: "13px !important",
    fontWeight: 500,
    color: "#0f172a"
  },
  moreDetailsHeader: {
    padding: "14px 24px !important",
    borderBottom: "1px solid #f1f5f9 !important",
    display: "flex !important",
    alignItems: "center !important",
    backgroundColor: "#F5F8FF !important",
  },
  moreDetailsTitle: {
    fontSize: "13px !important",
    fontWeight: "700 !important",
    color: "#1a56db !important",
    textTransform: "uppercase !important",
    letterSpacing: "0.8px !important",
  },
  detailCellWithBorder: {
    borderRight: "2px solid #f1f5f9 !important",
    "&:last-child": {
      borderRight: "none !important",
    },
  },
  detailsDates: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 0,
    borderTop: "1px solid #f1f5f9",
  },
  cardContentSection: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  detailsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 0,
  },
  detailCell: {
    padding: "16px 20px",
    borderRight: "2px solid #f1f5f9",
    "&:last-child": {
      borderRight: "none",
    },
  },
  detailCellLabel: {
    fontSize: "12px !important",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.8,
    color: "#94a3b8",
    marginBottom: 6,
  },
  detailCellValue: {
    fontSize: "14px !important",
    fontWeight: 600,
    color: "#0f172a",
  },
  statusChip: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 6px",
    borderRadius: 6,
    fontSize: "12px !important",
    fontWeight: 600,
  },
  formSection: {
    display: "flex",
    flexDirection: "column"
  },
  formLabel: {
    fontSize: "13px !important",
    fontWeight: 600,
    color: "#64748b"
  },
  autocompleteField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      borderColor: "#e2e8f0",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#cbd5e1",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#1a56db",
        borderWidth: "2px",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "13px !important",
      fontWeight: 500,
      color: "#0f172a",
    },
    "& .MuiTextField-root": {
      marginTop: "0.2rem",
    },
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    minHeight: "40px",
    padding: "8px 12px",
    backgroundColor: "#f8fafc",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
  },
  autocompleteDropdown: {
    borderRadius: "8px !important",
    overflow: "hidden",
  },
  technicianChip: {
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    color: "#fff",
    fontWeight: 600,
    fontSize: "12px !important",
    marginLeft: "4px",
  },
  chipDeleteIcon: {
    color: "#fff",
    fontSize: "16px !important",
    "&:hover": {
      color: "red",
    },
  },
  actionButtons: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  submitBtn: {
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    color: "#fff",
    borderRadius: 10,
    fontSize: "14px !important",
    fontWeight: 600,
    textTransform: "none",
    padding: "10px 16px",
    boxShadow: "0 2px 8px rgba(26, 86, 219, 0.35)",
    transition: "all 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 16px rgba(26, 86, 219, 0.45)",
    },
    "&:disabled": {
      background: "#cbd5e1",
      boxShadow: "none",
    },
  },
  cancelBtn: {
    borderRadius: 10,
    fontSize: "14px !important",
    fontWeight: 600,
    textTransform: "none",
    padding: "10px 16px",
    borderColor: "#e2e8f0",
    color: "#64748b",
    border: "1.5px solid #e2e8f0",
    transition: "all 0.2s",
    "&:hover": {
      borderColor: "#cbd5e1",
      backgroundColor: "#f8fafc",
    },
  },
  dividerLine: {
    height: 1,
    background: "linear-gradient(to right, transparent, #e2e8f0, transparent)",
    margin: "16px 0",
  },
  headerIconSvg: {
    fontSize: "22px !important",
    color: "white",
  },
  baseStatusIcon: {
    fontSize: "18px !important",
    marginRight: 4,
  },
  cancelledStatusIcon: {
    color: "#dc2626",
  },
  newStatusIcon: {
    color: "#2563eb",
  },
  inProgressStatusIcon: {
    color: "#f59e0b",
  },
  moreDetailsCard: {
    marginBottom: 20,
  },
}));
const ManageInspection = (props) => {
  let roleID;
  const history = useHistory();
  const dispatch = useDispatch();
  const [technicians, setTechnicians] = useState([]);
  const [technicianArray, setTechnicianArray] = useState([]);
  const classes = useStyles();
  const [makeSelected] = useContext(Context);

  const [details, setDetails] = useState({
    jobId: "",
    status: "",
    inspectionDate: "",
    year: "",
    modelName: "",
    market: "",
    plantDetails: "",
    endDate: "",
  });

  if (props && props.location && props.location.rowdata === undefined) {
    history.replace("/inspection-job");
  }

  useEffect(async () => {
    if (props && props.location && props.location.rowdata !== undefined) {
      await dispatch(OAuthActions.getRole()).then(function (roles) {
        if (roles) {
          roleID = roles.find((c) => c.name === "Technician").uid;
        }
      });
      let technicianList = {};

      await dispatch(
        OAuthActions.getBasicDetailsbyJobid(props.location.rowdata.jobId)
      ).then(function (tchnData) {
        if (tchnData) {
          setDetails(tchnData);
          technicianList = tchnData.technicianList;
        }
      });

      await dispatch(OAuthActions.getUsers(makeSelected.uid, roleID)).then(
        function (tchnData) {
          if (tchnData) {
            const activeUser = tchnData._embedded.userLists.filter(
              (m) => m.isActive === true
            );
            setTechnicians(activeUser);
            const preSelectedTechnician = [];
            technicianList.map((data) => {
              tchnData._embedded.userLists.find((c) => {
                if (c.uid === data.uid) {
                  preSelectedTechnician.push(data);
                }
              });
            });
            setTechnicianArray([...preSelectedTechnician]);
          }
        }
      );
    }
  }, [makeSelected]);

  const getStatusIcon = (status) => {
    if (status === "CANCELLED") {
      return <HighlightOffOutlinedIcon className={`${classes.baseStatusIcon} ${classes.cancelledStatusIcon}`} />;
    }
    if (status === "NEW") {
      return <DescriptionOutlinedIcon className={`${classes.baseStatusIcon} ${classes.newStatusIcon}`} />;
    }
    if (status === "IN_PROGRESS") {
      return <HourglassEmptyOutlinedIcon className={`${classes.baseStatusIcon} ${classes.inProgressStatusIcon}`} />;
    }
    return null;
  };

  const getStatusColor = (status) => {
    if (status === "CANCELLED") return { bg: "#fee2e2", text: "#991b1b" };
    if (status === "NEW") return { bg: "#dbeafe", text: "#1e40af" };
    if (status === "IN_PROGRESS") return { bg: "#fef3c7", text: "#854d0e" };
    return { bg: "#f1f5f9", text: "#475569" };
  };

  const statusColor = getStatusColor(details.status);

  return (
    <>
      <Box className={classes.page}>
        {/* Header */}
        <Box className={classes.header}>
          <Box className={classes.headerLeft}>
            <Box className={classes.headerIcon}>
              <DescriptionOutlinedIcon className={classes.headerIconSvg} />
            </Box>
            <Typography variant="h5" className={classes.title}>
              Manage Inspection Job
            </Typography>
          </Box>
        </Box>

        {/* Job Details Card */}
        <Card className={`${classes.card} ${classes.cardFlexContainer}`}>
          <Grid item xs={12} sm={2}>
            <img src={createInspectionJob} className={classes.gridImageContainer} />
          </Grid>
          <CardContent className={classes.cardContentContainer}>
            <Typography className={classes.infoTitle}>Job Information</Typography>

            <Box className={classes.fieldRow}>
              <Typography className={classes.fieldLabel}>Job ID</Typography>
              <Typography className={classes.fieldValue}>{details.jobId}</Typography>
            </Box>

            <Box className={classes.fieldRow}>
              <Typography className={classes.fieldLabel}>Status</Typography>
              <Box
                className={classes.statusChip}
                style={{
                  backgroundColor: statusColor.bg,
                  color: statusColor.text,
                }}
              >
                {getStatusIcon(details.status)}
                <span>
                  {details.status === "IN_PROGRESS"
                    ? "IN PROGRESS"
                    : details.status}
                </span>
              </Box>
            </Box>

            <Box className={classes.fieldRow}>
              <Typography className={classes.fieldLabel}>Inspection Date</Typography>
              <Typography className={classes.fieldValue1}>
                {details.inspectionDate
                  ? moment(details.inspectionDate).format("DD/MM/YYYY")
                  : "-"}
              </Typography>
            </Box>
          </CardContent>
        </Card>

        {/* More Details Card */}
        <Card className={`${classes.card} ${classes.moreDetailsCard}`}>
          <Box className={classes.moreDetailsHeader}>
            <Box className={classes.pageIconBox}>
              <MenuBookIcon className={classes.pageTitleIcon} />
            </Box>
            <Typography className={classes.moreDetailsTitle}>
              More Details
            </Typography>
          </Box>

          <Box className={classes.detailsGrid}>
            {[
              { label: "Model", value: details.modelName },
              { label: "Market", value: details.market },
              { label: "Year", value: details.year },
            ].map((item) => (
              <Box key={item.label} className={`${classes.detailCell} ${classes.detailCellWithBorder}`}>
                <Typography className={classes.detailCellLabel}>{item.label}</Typography>
                <Typography className={classes.detailCellValue}>{item.value}</Typography>
              </Box>
            ))}
          </Box>

          <Box className={classes.detailsDates}>
            {[
              { label: "Plant", value: details.plantDetails },
              { label: "Start Date", value: details.inspectionDate ? moment(details.inspectionDate).format("DD/MM/YYYY") : "" },
              { label: "End Date", value: details.endDate ? moment(details.endDate).format("DD/MM/YYYY") : "" },
            ].map((item) => (
              <Box key={item.label} className={classes.detailCell}>
                <Typography className={classes.detailCellLabel}>{item.label}</Typography>
                <Typography className={classes.detailCellValue}>
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Card>

        {/* Technician Assignment Card */}
        <Card className={classes.card}>
          <Box className={classes.moreDetailsHeader}>
            <Box className={classes.pageIconBox}>
              <GroupAddOutlinedIcon className={classes.pageTitleIcon} />
            </Box>
            <Typography className={classes.moreDetailsTitle}>
              Assign Technicians
            </Typography>
          </Box>

          <Box className={classes.cardContentSection}>
            <Box className={classes.formSection}>
              <Typography className={classes.formLabel}>
                Assign Additional Technician or Transfer technician
              </Typography>
              <Autocomplete
                multiple
                options={technicians}
                value={technicianArray}
                onChange={(event, newValue) => {
                  let newValueSet = newValue.reduce((accumulator, current) => {
                    if (!accumulator.some((x) => x.uid === current.uid)) {
                      accumulator.push(current);
                    }
                    return accumulator;
                  }, []);

                  setTechnicianArray([
                    ...new Set([...newValueSet]),
                  ]);
                }}
                getOptionLabel={(option) =>
                  `${option.firstName} ${option.lastName}`
                }
                classes={{
                  paper: classes.autocompleteDropdown,
                }}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip
                      label={`${option.firstName} ${option.lastName}`}
                      {...getTagProps({ index })}
                      className={classes.technicianChip}
                      onDelete={getTagProps({ index }).onDelete}
                      deleteIcon={
                        <HighlightOffOutlinedIcon
                          className={classes.chipDeleteIcon}
                        />
                      }
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder={technicianArray.length === 0 ? "Search and select technicians" : ""}
                    variant="outlined"
                    className={classes.autocompleteField}
                    InputLabelProps={{
                      shrink: true,
                      style: { color: "#64748b", fontWeight: 600 },
                    }}
                  />
                )}
                className={classes.autocompleteField}
              />
            </Box>

            <Box className={classes.actionButtons}>
              <Button
                variant="outlined"
                className={classes.cancelBtn}
                onClick={history.goBack}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={classes.submitBtn}
                onClick={() => {
                  const technicianList = [];
                  technicianArray.map((data) => {
                    technicianList.push(data.uid);
                  });
                  const data = {
                    technicianList,
                  };
                  dispatch(
                    OAuthActions.cancelUpdateJob(details.jobId, data)
                  ).then(function (data) {
                    if (data.status === 200) {
                      dispatch(
                        setSnackbar(
                          true,
                          "success",
                          "Technician Updated Successfully"
                        )
                      );
                      history.goBack();
                    } else {
                      dispatch(
                        setSnackbar(
                          true,
                          "error",
                          "Technician update Unsuccessful. Please try again later."
                        )
                      );
                    }
                  });
                }}
                disabled={!technicianArray.length}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default ManageInspection;
